import { useState } from 'react'
import { IconPlayerPlayFilled } from '@tabler/icons-react'
import YouTube from 'react-youtube'

interface TranscriptData {
  submission: any
  transcript: any
}
export const VideoSection = ({
  transcriptData,
}: {
  transcriptData: TranscriptData
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const videoId = transcriptData?.submission?.youtube_url?.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&?]+)/
  )?.[1]

  if (!videoId) {
    return null
  }

  return (
    <div className="flex h-fit w-full flex-col gap-4 overflow-hidden rounded-lg">
      <div className="relative w-full pt-[56.25%]">
        {isLoading && (
          <div className="absolute top-0 left-0 h-full w-full animate-pulse bg-gray-200">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IconPlayerPlayFilled className="h-8 w-8" />
              </div>
            </div>
          </div>
        )}
        <YouTube
          videoId={videoId}
          className="absolute top-0 left-0 h-full w-full"
          opts={{
            width: '100%',
            height: '100%',
            playerVars: {
              autoplay: 0,
            },
          }}
          onReady={() => setIsLoading(false)}
        />
      </div>
    </div>
  )
}
